module.exports = {
  title: {
    product: 'Product',
    productCatalog: 'End Of Season Sale',
    subProductCatalog: 'Up to 70% off',
    finalTile: 'Final Tile',
  },
  header: {
    button: {
      update: 'Update',
      create: 'Create',
      publish: 'Publish',
    },
  },
  table: {
    tooltip: {
      soldOut: 'Sold out',
      normal: 'Remove sold out',
      hide: 'Hide',
      show: 'Show',
      membership: {
        champion: 'Only Champion can purchase the product',
        free: 'All players can purchase the product',
      },
      edit: 'Edit',
      inactive: 'InActive',
      active: 'Active',
    },
    title: {
      product: 'Product',
      title: 'Title',
      soldOut: 'Sold out',
      index: 'No',
      action: 'Action',
      maxQty: 'Maximum Allowed',
      membership: 'Membership Participation',
      show: 'Active',
    },
  },
  form: {
    productID: 'Product ID',
    productName: 'Product Name',
    show: 'Show',
    title: 'Title',
    maximumQuanity: 'Maximum Quantity (Qty)',
    images: 'Product Image URL',
    btnUpdateProduct: 'Update',
    textColor: 'Text Color',
    colorOpacity: 'Background opacity',
    dragMessage: 'Draft image of Promotion here',
    uploadImage: 'Upload image',
    updateProduct: 'Update Product',
    discountItem: 'Update Discount Item',
    membershipExclusive: 'Membership Exclusive',
    buttonText: 'Button Text',
    save: 'Save',
    priceColor: 'Price Color',
    titleColor: 'Title Color',
    buttonBGColor: 'Button Background Color',
    buttonTextColor: 'Button Text Color',
    setting: {
      participationLevelZero: 'Free',
      participationLevelOne: 'Champion',
    },
    titleAlign: 'Title Align',
    maxQuantity: 'Maximum Quantity',
    tag: 'Tag',
    link: 'Link',
    logo: 'Logo',
    upload: 'Upload',
    update: 'Update',
    create: 'Create',
    updateFinalTile: 'Edit Collection Tile',
    createFinalTile: 'Create Collection Tile',
    countries: 'Country',
    image3x4: 'Please upload a 4x3 image',
    image1x1: 'Please upload a 1x1 image',
    imageUpload: '*Upload an image',
  },
  validate: {
    imageBlank: 'Please upload an image!',
    logoBlank: 'Please upload a logo!',
    titleBlank: 'Please input title!',
    countryBlank: 'Please select country!',
    tagBlank: 'Please input tag!',
    linkBlank: 'Please input a link!',
    maximumQuantity: 'Default value is 6 for Ball type product, and default of 1 for other types',
  },
  popup: {
    title: 'Confirm',
    okBtn: 'Yes',
    cancelBtn: 'No',
    delete: 'Are you sure you want to delete this card?',
    edit: 'Are you sure to edit this Discount Item?',
    editFinal: 'Are you sure to edit this Final Tile?',
    soldOut: 'Are you sure you want to sold out this product?',
    removeSoldOut: 'Are you sure you want to remove sold out this product?',
    show: 'Are you sure you want to show this product?',
    hide: 'Are you sure you want to hide this product?',
    update: 'Are you sure you want to update this product?',
    close: 'Are you sure you want to close this card?',
    confirmPassword: 'Please input your password to confirm.',
    enable: 'Are you sure you want to enable this Discount Item?',
    disable: 'Are you sure you want to disable this Discount Item?',
    enableFinalTile: 'Are you sure you want to enable this Final Tile?',
    disableFinalTile: 'Are you sure you want to disable this Final Tile?',
  },
  message: {
    updateSoldOutProductError: 'Failed to update sold out this product.',
    updateSoldOutProductSuccess: 'Product Sold Out successfully updated.',
    updateProductSuccess: 'Product successfully updated.',
    updateDiscountItemSuccess: 'Discount Item successfully updated.',
    updateProductError: 'Failed to update this product.',
    updateProductEcomError: 'Failed to update ECOM product.',
    updateProductEcomSuccess: 'ECOM Product successfully updated.',
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again',
      maxItem: 'Please disable another tile before enabling a new one.',
    },
    success: {
      updateFinalTile: 'Final Tile successfully updated.',
      createFinalTile: 'Final Tile successfully added.',
      deleteFinalTile: 'Final Tile successfully deleted.',
    },
  },
};
